﻿import config from "../config"
const baseUrl = config.base_url + "mini_tree/"
export default {
    page: {
        url:  baseUrl + "page",
        type: "post",
    },
    list: {
        url:  baseUrl + "list",
        type: "post",
    },
    add: {
        url:  baseUrl + "insert",
        type: "post",
    },
    edit: {
        url:  baseUrl + "update",
        type: "post",
    },
}

